export default class SearchLightbox {
  constructor() {
    this.$lightbox = $('#search-lightbox')
    this.$backdrop = $('.search-lightbox-backdrop')
    this.$searchInput = $('.search-bar-input')
    this.$searchClear = $('.search-bar-clear')
    this.$searchToggle = $('.search-toggle')
    this.$searchForm = $('.search-bar-form')
    this.isOpen = false
  }

  init() {
    if (this.$lightbox.length) {
      this.bindEvents()
    }
  }

  bindEvents() {
    this.$searchToggle.on('click', (e) => {
      e.preventDefault()
      this.isOpen ? this.close() : this.open()
    })

    this.$backdrop.on('click', () => this.close())

    // Close search when mobile menu or desktop mega menu opens
    $('.hamburger-menu').on('click', () => {
      if (this.isOpen) this.close()
    })

    // Close the open search when the user moves to the menu — but only after a
    // short dwell, and never while heading into the search box itself. Without
    // the delay, merely brushing a menu item on the way to the input closed the
    // box before the user could type.
    let menuCloseTimer = null
    const MENU_CLOSE_DELAY = 400

    const cancelMenuClose = () => {
      if (menuCloseTimer) {
        clearTimeout(menuCloseTimer)
        menuCloseTimer = null
      }
    }

    $('.main-menu-ul > li')
      .on('mouseenter', () => {
        if (!this.isOpen) return
        cancelMenuClose()
        menuCloseTimer = setTimeout(() => {
          menuCloseTimer = null
          if (this.isOpen) this.close()
        }, MENU_CLOSE_DELAY)
      })
      .on('mouseleave', cancelMenuClose)

    // Entering the search box (or focusing the input) cancels any pending close.
    this.$lightbox.on('mouseenter', cancelMenuClose)
    this.$searchInput.on('focus', cancelMenuClose)

    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close()
      }
    })

    this.$searchForm.on('submit', () => {})

    // Custom clear (×): empty the field and refocus it.
    this.$searchClear.on('click', () => {
      this.$searchInput.val('').focus()
    })

    this.$lightbox.on('keydown', (e) => this.trapFocus(e))
  }

  open() {
    // Close mobile menu first (isOpen is still false here, so our listener won't loop)
    if ($('html').hasClass('is-open-menu')) {
      $('.hamburger-menu').trigger('click')
    }

    const headerHeight = $('#header').outerHeight() || 96
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`)

    this.$lightbox.addClass('is-open')
    this.$lightbox.attr('aria-hidden', 'false')
    $('body').addClass('search-lightbox-open')
    this.isOpen = true

    setTimeout(() => {
      this.$searchInput.focus()
    }, 300)
  }

  close() {
    this.$lightbox.removeClass('is-open')
    this.$lightbox.attr('aria-hidden', 'true')
    $('body').removeClass('search-lightbox-open')
    this.isOpen = false
    this.$searchInput.val('')
  }

  trapFocus(e) {
    if (e.key === 'Tab') {
      const focusableElements = this.$lightbox.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      const firstElement = focusableElements.first()
      const lastElement = focusableElements.last()

      if (e.shiftKey && $(document.activeElement).is(firstElement)) {
        e.preventDefault()
        lastElement.focus()
      } else if (!e.shiftKey && $(document.activeElement).is(lastElement)) {
        e.preventDefault()
        firstElement.focus()
      }
    }
  }
}

new SearchLightbox().init()
